import './page/acris-faq-create';
import './page/acris-faq-detail';
import './page/acris-faq-list';
import './component/acris-faq-document-form';
import './component/media/acris-faq-document-upload';
import './component/form/acris-edit-document-modal';
import './component/base/acris-faq-document';

const { Module } = Shopware;

Module.register('acris-faq', {
    type: 'plugin',
    name: 'AcrisFaq',
    title: 'acris-faq.general.mainMenuItemGeneral',
    description: 'acris-faq.general.description',
    color: '#a6c836',
    icon: 'regular-question-circle',
    favicon: 'icon-module-settings.png',

    routes: {
        index: {
            component: 'acris-faq-list',
            path: 'index',
            meta: {
                parentPath: 'acris.faq.list.index'
            }
        },
        detail: {
            component: 'acris-faq-detail',
            path: 'detail/:id',
            meta: {
                parentPath: 'acris.faq.index'
            }
        },
        create: {
            component: 'acris-faq-create',
            title: 'Test',
            path: 'create',
            meta: {
                parentPath: 'acris.faq.index'
            }
        }
    }
});
